var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3ColumnGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 18,
    y1: 36,
    x2: 18,
    y2: -0.0000263875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009245"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D9E021"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M15.7,28.6h4.6c0.5,0,0.8-0.4,0.8-0.8V8.2c0-0.5-0.4-0.8-0.8-0.8h-4.6c-0.5,0-0.8,0.4-0.8,0.8 v19.6C14.8,28.3,15.2,28.6,15.7,28.6z M23.2,28.6h4.6c0.5,0,0.8-0.4,0.8-0.8V8.2c0-0.5-0.4-0.8-0.8-0.8h-4.6c-0.5,0-0.8,0.4-0.8,0.8 v19.6C22.4,28.3,22.8,28.6,23.2,28.6z M8.1,28.6h4.6c0.5,0,0.8-0.4,0.8-0.8V8.2c0-0.5-0.4-0.8-0.8-0.8H8.1c-0.5,0-0.8,0.4-0.8,0.8 v19.6C7.3,28.3,7.7,28.6,8.1,28.6z M35.1,0.9C34.6,0.3,33.8,0,33,0H3C2.2,0,1.4,0.3,0.9,0.9C0.3,1.4,0,2.2,0,3v30 c0,0.8,0.3,1.6,0.9,2.1C1.4,35.7,2.2,36,3,36h30c1.6,0,3-1.4,3-3V3C36,2.2,35.7,1.4,35.1,0.9z M33,33H3V3h30V33z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3ColumnGreen);
export default __webpack_public_path__ + "static/media/3 column_green.286e1a1fe2eeff883c0d9a6018281a73.svg";
export { ForwardRef as ReactComponent };